import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const dossiersSlice = createSlice({
    name: 'dossiers',
    initialState: {
        data: [],
        detailsDossiers : [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsDossiers.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsDossiers.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.detailsDossiers = action.payload
        })
        .addCase(fetchDetailsDossiers.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchDossiers.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDossiers.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchDossiers.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createDossier.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createDossier.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createDossier.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteDossier.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteDossier.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteDossier.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchDossiers = createAsyncThunk(
    'dossiers/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/chantier.dossier.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch dossiers')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsDossiers = createAsyncThunk(
    'Dossiers/fetchDetails',
    async (id) => {
        const data = {'id':id.id}
        try {
            const Dossier = await BaseService.post(
                `/XML/chantier.dossier.load/get_contenu`,data
            )
            

            return Dossier.data
        } catch (error) {
            throw new Error('Failed to fetch Dossiers')
        }
    }
)

export const createDossier = createAsyncThunk(
    'dossiers/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/dossiers', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/dossiers')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editDossier = createAsyncThunk('dossiers/edit', async (payload) => {
    const { data, formik, navigate } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.put(`/dossiers/${data?.id}`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/dossiers')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})

export const deleteDossier = createAsyncThunk(
    'dossier/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/dossiers/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.dossiers.data
export const selectIsLoading = (state) => state.dossiers.isLoading
export const selectError = (state) => state.dossiers.error
export const selectIsDeleted = (state) => state.dossiers.isDeleted
export const selectCurrentPage = (state) => state.dossiers.currentPage

export default dossiersSlice.reducer
